/* eslint-disable prefer-reflect */

import { DEFAULTGEODATA, MAPERRORMESSAGES } from "../../constants/index.js";
import { i18n } from "@base/common/libs/i18n/index.js";

export function getTimeZoneLocation() {
  return [13.3434, 80.456456];
}
export function constructMapUrl(latitude, longitude, placeId) {
  if (latitude && longitude) {
    return `https://www.google.com/maps/search/?api=1&query=${parseFloat(
      latitude
    )}%2C${parseFloat(longitude)}${
      placeId ? `&query_place_id=${placeId}` : ""
    }`;
  }
  return null;
}

export function normalizeMapValue(data = null) {
  if ((data === null || Object.keys(data).length) === 0) return {};
  let value = { ...data };
  if (!value.geometry && !value.properties) return value;
  value = {
    ...value.properties,
    Latitude: value.geometry.coordinates[1],
    Longitude: value.geometry.coordinates[0]
  };
  return value;
}

export function formatAddress(addressArray = []) {
  let placeInfo = { ...DEFAULTGEODATA.LOCDATA };
  if (addressArray && addressArray.length > 0) {
    addressArray.forEach((el) => {
      if (
        el.types.find(
          (type) => ["locality"].includes(type) //administrative_level_1
        )
      ) {
        placeInfo.City = el.long_name;
      } else if (
        el.types.find((type) =>
          ["state", "administrative_area_level_1"].includes(type)
        )
      ) {
        placeInfo.State = el.long_name;
      } else if (el.types.find((type) => type === "country")) {
        placeInfo.Country = el.long_name;
      } else if (el.types.find((type) => type === "postal_code")) {
        placeInfo.ZipCode = el.long_name;
      } else if (
        el.types.find((type) =>
          [
            "sublocality_level_1",
            "sublocality_level_2",
            "sublocality"
          ].includes(type)
        )
      ) {
        placeInfo.Area = el.long_name;
      }
    });
  }
  return placeInfo;
}

function createDOMElement(elementProperties, mapProperties) {
  let { Id, elementType } = elementProperties;

  let element = document.createElement(elementType);
  element.id = Id;
  if (elementType === "script") {
    let { mapUrl, mapCallback, apiKey } = mapProperties;
    let url = getUrl(mapUrl, apiKey, mapCallback);
    element.async = elementProperties.async;
    element.defer = elementProperties.defer;
    element.src = url;
  }
  return element;
}

function deleteDomElementById(elementId) {
  let element = document.getElementById(elementId);
  if (element) {
    element.remove();
  }
}

export function unloadMapScript(mapProperties) {
  let { mapElement, scriptElement } = mapProperties;
  delete window.map;
  delete window.geocoder;
  delete window.google;
  delete window.gm_authFailure;
  deleteDomElementById(mapElement["Id"]);
  deleteDomElementById(scriptElement["Id"]);
}

function getUrl(url, key, callback) {
  return `${url}${key}${callback}`;
}

export function loadMapScript(apiKey, mapProperties, setKeyValidity) {
  let { OnLoadClearMap = true, mapElement, scriptElement } = mapProperties;
  if (OnLoadClearMap) {
    unloadMapScript(mapProperties);
  }

  let mapDiv = createDOMElement(mapElement, mapProperties);
  if (mapDiv) {
    document.body.appendChild(mapDiv);
  }

  //Method will be triggered when we pass the invalid Key / any other auth error.
  window.gm_authFailure = function mapAuth() {
    setKeyValidity(false);
  };
  window.initHiddenMap = function initMap() {
    window.map = new window.google.maps.Map(
      document.getElementById(mapElement["Id"]),
      {
        center: { lat: -34.397, lng: 150.644 },
        zoom: 8
      }
    );
    window.geocoder = new window.google.maps.Geocoder();
    window.geocoder.geocode(
      { location: { lat: -34.397, lng: 150.644 } },
      (results, status) => {
        if (status === "OK") {
          console.info("results", results, status);
          setKeyValidity(true);
        } else {
          console.info("Geocoder failed due to: " + status, results);
          setKeyValidity(false);
        }
      }
    );
  };

  let mapScript = createDOMElement(scriptElement, mapProperties);
  if (mapScript) {
    document.head.appendChild(mapScript);
  }
}

export function handleMapErrors(status) {
  let errMessage = status;
  if (MAPERRORMESSAGES[status]) {
    errMessage = i18n._(MAPERRORMESSAGES[status]);
  }
  return errMessage;
}
